import { TYPES_2FA_OTP } from "../../../common/const";

export const ANALYTICS_EVENT_TYPE = {
  POPUP: "popup_view",
  CLICK: "click",
  PAGE_VIEW: "page_view",
};
export const ANALYTICS_EVENT_SUBSCREEN = {
  [TYPES_2FA_OTP.SMS]: "2fa_sms",
  [TYPES_2FA_OTP.CALL]: "2fa_call",
  [TYPES_2FA_OTP.PUSH]: "2fa_push",
  [TYPES_2FA_OTP.GOOGLE]: "2fa_gauth",
};
export const ANALYTICS_BUTTON_NAME = {
  SUBMIT: "submit",
  DOWNLOAD: "show_popup_download",
  GO_TO_SMS: "go_to_2fa_sms",
  CLOSE: "close",
  PASTE: "paste",
  RESEND: "resend",
};
